import { render, staticRenderFns } from "./SCEmployeeRoleFilters.vue?vue&type=template&id=4ff0051e"
import script from "./SCEmployeeRoleFilters.vue?vue&type=script&lang=js"
export * from "./SCEmployeeRoleFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports